import axios from 'axios';

// Action types
export const SET_ERROR = 'SET_ERROR';

// Action creator
export const setFv = (num_se, hook_status) => {
	return async (dispatch) => {
		//console.log(`in setFv, num_se`, num_se);
		if (num_se <= 1) {
			regForm(hook_status, dispatch);
		}
	};
};

function regForm(hook_status, dispatch) {
	if (hook_status == 'live') {
		const formRoot = document.getElementById('form-inputs');
		const preview = formRoot?.getAttribute('data-preview');
		if (preview === '1' || preview === 'true') {
			dispatch({type: 'SET_FV', payload: null});
			return;
		}
		// Check if we're in Shopcarts controller - if so, don't create FormValidation here
		// as it will be handled by the checkout.php page
		const controller = document.querySelector('[data-controller]')?.getAttribute('data-controller');
		if (controller && controller.includes('Shopcarts')) {
			console.log('Shopcarts controller detected, skipping Redux FormValidation creation');
			// Set a placeholder so React components know FormValidation will be available later
			dispatch({type: 'SET_FV', payload: null});
			return;
		}
		if (typeof FormValidation === 'undefined') {
			dispatch({type: 'SET_FV', payload: null});
			return;
		}

		const form = document.getElementById('reg-form');

		const validator = FormValidation.formValidation(
			form,
			{
				plugins: {
					trigger: new FormValidation.plugins.Trigger(),
					bootstrap: new FormValidation.plugins.Bootstrap5({
						rowSelector: '.form-group',
						eleInvalidClass: '',
						eleValidClass: ''
					}),
					autoFocus: new FormValidation.plugins.AutoFocus(),
					submitButton: new FormValidation.plugins.SubmitButton(),
					declarative: new FormValidation.plugins.Declarative({
						html5Input: true
					})
				}
			}
		);

		dispatch({type: 'SET_FV', payload: validator});
	}
}

// Turnstile actions
export const setTurnstileToken = (token) => ({
	type: 'SET_TURNSTILE_TOKEN',
	payload: token
});

export const setTurnstileTimestamp = (timestamp) => ({
	type: 'SET_TURNSTILE_TIMESTAMP',
	payload: timestamp
});